import React, { useContext, useEffect, useState } from 'react';

import { Tab, Tabs } from '@material-ui/core';

import { GlobalContext } from '../../../store';

import ClubBasicInfo from '../ClubBasicInfo';
import ClubOfficers from '../ClubOfficers';
import ClubStaticPages from '../ClubStaticPages';

interface IProps {
  clubId: string;
}

const ClubInfoRoot = (props: IProps) => {
  const { clubId } = props;

  const { actions, clubs } = useContext(GlobalContext);

  const [activeTab, setActiveTab] = useState(0);
  const [leaveTab, setLeaveTab] = useState(0);
  const [direction, setDirection] = useState('');

  useEffect(() => {
    actions.clubs.get(Number(clubId));
  }, []);

  const club = clubs[Number(clubId)];

  const setTab = (_: any, activeTabNum: number) => {
    const leaveTabNum = activeTab;
    if (leaveTabNum !== activeTabNum) {
      setActiveTab(activeTabNum);
      setLeaveTab(leaveTabNum);
      setDirection(leaveTabNum < activeTabNum ? 'ltr' : 'rtl');
    }
  };

  const steps = [
    {
      content: <ClubStaticPages clubId={Number(clubId)} club={club} />,
      label: 'POLICIES'
    },
    {
      content: <ClubOfficers club={club} />,
      label: 'OFFICERS'
    },
    {
      content: <ClubBasicInfo club={club} />,
      label: 'CLUB INFO'
    }
  ];

  return (
    <div className="club-info-root admin-layout">
      <div className="club-info-root-bar-wrapper">
        <div className="club-info-root-tab-menu override">
          <Tabs
            value={activeTab}
            onChange={setTab}
            variant="fullWidth"
            centered={true}
            classes={{
              indicator: 'tab-indicator',
              scroller: 'scroll-container'
            }}
          >
            {steps.map(({ label }, index) => (
              <Tab
                label={label}
                key={`club-settings-tab-${index}`}
                className="admin-tab button"
                classes={{ wrapper: 'tab-label' }}
              />
            ))}
          </Tabs>
        </div>
      </div>

      <div className={`slider ${direction} admin-layout`}>
        {steps.map(({ content }, index) => (
          <div
            key={`club-settings-step-${index}`}
            className={`slide top admin-wrapper club-settings ${
              activeTab === index ? 'active' : ''
            } ${leaveTab === index ? 'leave' : ''}`}
          >
            {content}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClubInfoRoot;
